import { NewsModal } from "@/components/NewsModal";
import { ReactNode, useEffect } from "react";
import styles from "@/pages/index.module.css";
import { Link } from "react-router";

export default function NewsPage(): ReactNode {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={styles.modalPage}>
      <Link className={styles.modalPageBackdrop} to="/" />
      <NewsModal />
    </div>
  );
}
